import React, { createContext, useState, useEffect, useContext, ReactNode } from 'react'
import axios from 'axios'
import { v4 as uuid } from 'uuid'
import Cookies from 'js-cookie'

const TOG_ENDPOINT = 'https://saude.zelas.com.br/_sessions'
const TOG_NAMESPACE = 'saude_zelas'
const COOKIE_NAME = 'tog_session'

const getTogSession = async () => {
  const togSession = Cookies.get(COOKIE_NAME) || '{}'
  const parsedTogSession = JSON.parse(togSession)

  if (parsedTogSession?.id?.length) {
    return parsedTogSession
  }

  const SESSION_ID = window?.LeadTracking?.getCookie?.() || uuid()
  const ENDPOINT = `${TOG_ENDPOINT}/${TOG_NAMESPACE}/${SESSION_ID}`
  const { data } = await axios.get(ENDPOINT)

  Cookies.set(COOKIE_NAME, JSON.stringify(data))

  return data
}

const FlagsContext = createContext({
  flags: {
    modal_mql: true,
    simulador_pme: false
  }
})

export const FlagsProvider = ({ children }: { children: ReactNode }) => {
  const [togData, setTogData] = useState({
    flags: {
      modal_mql: false,
      simulador_pme: false
    }
  })

  useEffect(() => {
    getTogSession()
      .then(data => setTogData(data))
  }, [])

  return (
    <FlagsContext.Provider value={togData}>
      {children}
    </FlagsContext.Provider>
  )
}

export const useFlags = () => {
  const context = useContext(FlagsContext)

  return context
}
